export const COMPANY_STATUS = {
    OPEN: 1,
    CLOSED: 2,
};

export const ChatType = {
    SMS: 0,
    WhatsApp: 1,
};

export const Completeness = {
    Low: 1,
    Medium: 2,
    High: 3,
};

export const paymentMethods = [
    { name: 'cash', value: 0 },
    { name: 'visa', value: 1 },
    { name: 'mastercard', value: 2 },
    { name: 'creditCard', value: 3 },
    { name: 'debitCard', value: 4 },
    { name: 'applePay', value: 5 },
    { name: 'androidPay', value: 6 },
    { name: 'paypal', value: 7 },
    { name: 'americanExpress', value: 8 },
    { name: 'discover', value: 9 },
    { name: 'invoice', value: 10 },
    { name: 'moneyOrder', value: 11 },
    { name: 'personalCheck', value: 12 },
    { name: 'bitcoin', value: 13 },
    { name: 'square', value: 14 },
    { name: 'travelersCheck', value: 15 },
    { name: 'jcb', value: 16 },
    { name: 'dinersClub', value: 17 },
];

export const PaymentTypes = {
    cash: 0,
    visa: 1,
    mastercard: 2,
    creditCard: 3,
    debitCard: 4,
    applePay: 5,
    androidPay: 6,
    paypal: 7,
    americanExpress: 8,
    discover: 9,
    invoice: 10,
    moneyOrder: 11,
    personalCheck: 12,
    bitcoin: 13,
    square: 14,
    travelersCheck: 15,
    jcb: 16,
    dinersClub: 17,
};

export const LocationIntegrationStatus = {
    Connected: 1,
    Disconnected: 2,
    Unverified: 3,
    Pending: 4,
};
